import * as __vanilla_filescope__ from '@vanilla-extract/css/fileScope';
__vanilla_filescope__.setFileScope("src/styles.css.ts", "@paypalcorp/pp-react-tabs");
import { style, globalStyle } from '@vanilla-extract/css';
import { tokens } from '@paypalcorp/pp-react-theme';
import { focusStyles, utilStyles, rgba } from '@paypalcorp/pp-react-utils';
import { textStyles } from '@paypalcorp/pp-react-text';
import { elevationStyles } from '@paypalcorp/pp-react-elevation';
const {
  variables
} = utilStyles;
const tabMaxWidth = '11.5rem';
const tabMinWidth = '5.25rem';
const tabPaddingLeft = `calc(${tokens.space[400]} + ${tokens.space[300]})`;
const scrollBtnHeight = `calc(${tokens.size.tapTarget.default} * 2)`;
const tabContentMargin = `calc(${tokens.space[300]} * 3)`;
const noDisplay = {
  display: 'none'
};
const blockDisplay = {
  display: 'block'
};
export const tabsWrapperBase = style({
  position: 'relative'
}, 'tabs_wrapper_base');
export const base = style({
  overflowY: 'hidden',
  whiteSpace: 'nowrap',
  position: 'relative',
  scrollbarWidth: 'none',
  padding: `${tokens.space[300]} ${tokens.space[300]} ${tokens.space[300]} ${tabPaddingLeft}`,
  selectors: {
    '&::-webkit-scrollbar': {
      ...noDisplay
    }
  }
}, 'tabs_base');
export const tabsWrapper = style({
  display: 'flex',
  float: 'left',
  minHeight: tokens.size.field.sm,
  width: 'max-content',
  position: 'relative',
  selectors: {
    [`[dir='rtl'] &`]: {
      float: 'right'
    }
  }
}, 'tabs_wrapper');
export const tabsCenter = style({
  minWidth: '100%',
  width: 'auto',
  minHeight: tokens.size.field.sm,
  justifyContent: 'center',
  '@media': {
    [`(max-width: 120px)`]: {
      width: 'auto',
      justifyContent: 'flex-start'
    }
  }
}, 'tabs_center');
export const tabsBtn = style({
  ...blockDisplay,
  ...textStyles.buttonLgStyles,
  padding: `${tokens.space[150]} ${tokens.space[50]}`,
  minHeight: tokens.size.field.sm,
  minWidth: tabMinWidth,
  maxWidth: tabMaxWidth,
  marginInlineEnd: tokens.space[200],
  outline: 'none',
  position: 'relative',
  border: 'none',
  backgroundColor: 'transparent',
  whiteSpace: 'normal',
  wordWrap: 'break-word',
  textDecoration: 'none',
  flexShrink: 0,
  cursor: 'pointer',
  color: tokens.color.background.mediumContrast,
  zIndex: 1,
  ':last-of-type': {
    marginInlineEnd: 0
  },
  '::after': {
    content: '',
    position: 'absolute',
    inset: 0,
    border: 'none',
    pointerEvents: 'none',
    top: 'auto'
  },
  ':hover': {
    backgroundColor: tokens.color.background.surfaceHover,
    borderRadius: tokens.border.radius.xs,
    textDecoration: 'none'
  },
  ':active': {
    color: tokens.color.background.highContrast,
    textDecoration: 'none'
  },
  ':focus': {
    ...focusStyles.focusOffsetElementStyles,
    textDecoration: 'none',
    borderRadius: tokens.border.radius.xs,
    outlineOffset: 'unset',
    transform: 'none',
    transition: 'none'
  },
  ':visited': {
    textDecoration: 'none'
  }
}, 'tabs_btn');
export const tabsSlider = style({
  position: 'absolute',
  bottom: 0,
  left: 0,
  width: 0,
  height: tokens.border.thickness.emphasis,
  borderRadius: tokens.border.radius.tiny,
  borderBottom: `${tokens.border.thickness.emphasis} solid ${tokens.color.background.highContrast}`,
  transition: `all ${tokens.motion.duration.move.small} ${variables.ppuiEaseMoveSmall}`
}, 'tabs_slider');
export const tabsSelectedBtn = style({
  color: tokens.color.background.highContrast,
  ':hover': {
    textDecoration: 'none'
  }
}, 'tabs_selected_btn');
globalStyle(`${tabsSelectedBtn}:hover::after`, {
  borderRadius: tokens.border.radius.tiny,
  borderBottom: `${tokens.border.thickness.emphasis} solid ${tokens.color.background.highContrast}`
});
export const tabsScrollBtn = style({
  backgroundColor: tokens.color.background.surface,
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  opacity: 0,
  visibility: 'hidden',
  width: tokens.size.tapTarget.default,
  height: scrollBtnHeight,
  top: 0
}, 'tabs_scroll_btn');
export const tabsScrollBtnLeft = style({
  left: 0,
  background: `linear-gradient(
    90deg,
    ${tokens.color.background.surface} 47.45%,
    ${rgba(tokens.color.background.surface, '0')} 100%
  )`,
  zIndex: 1
}, 'tabs_scroll_btn_left');
export const tabsScrollBtnRight = style({
  right: 0,
  background: `linear-gradient(
    270deg,
    ${tokens.color.background.surface} 47.45%,
    ${rgba(tokens.color.background.surface, '0')} 100%
  )`,
  zIndex: 1
}, 'tabs_scroll_btn_right');
export const tabsScrollBtnVisible = style({
  visibility: 'visible',
  opacity: 1,
  transition: `visibility ${tokens.motion.duration.move.small},
    opacity ${tokens.motion.duration.move.small}`
}, 'tabs_scroll_btn_visible');
export const tabsArrowIcon = style([elevationStyles.level1, {
  color: tokens.color.primary.main,
  background: tokens.color.background.surface
}], 'tabs_arrow_icon');
export const tabsContent = style({
  margin: `0 ${tokens.space[300]} 0 ${tabContentMargin}`,
  ':focus': {
    outline: 'none'
  },
  selectors: {
    [`&[aria-hidden='true']`]: {
      ...noDisplay
    }
  }
}, 'tabs_content');
export const tabsContentFocus = style({
  ':focus': {
    boxShadow: `0 0 ${tokens.border.thickness.emphasis}
      ${tokens.border.thickness.emphasis} ${tokens.color.structure.focus}`
  }
}, 'tabs_content_focus');
export const hideBtn = style({
  ...noDisplay
}, 'hide_btn');
export const tabsContentVisible = style({
  ...blockDisplay
}, 'tabs_content_visible');
export const tabsContentHidden = style({
  ...noDisplay
}, 'tabs_content_hidden');
export const navBackground = style([elevationStyles.level3, {
  background: tokens.color.background.surface
}], 'tabs_nav_background');
__vanilla_filescope__.endFileScope();
